import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
//import "rsuite/dist/rsuite.min.css";
import { Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import AuthService from "../../../services/auth.service";
import Modal from "react-bootstrap/Modal";
import check from "../../../picture/check.png";
import Select from "react-select";
import { color, style } from "@mui/system";
import "./Styles.css";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import DataAccessories from "../../../file/data-accessories.json";
import { cleanDigitSectionValue } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";
import Static_modal from "../etc/Static_modal";
//icons
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";

function Datadrone(prop) {
  let Navigate = useNavigate();
  function editdrone() {
    //setDisabless(false);
    Navigate("/profile/editprofileuser", {
      state: {
        href: window.location.href,
      },
    });
  }
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const { state } = useLocation();

  const form1 = useRef();
  const [checkuserdata, setcheckuserdata] = useState(false);
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState("");
  const [dataEdit, setDataEdit] = useState("");
  const [saveedit, setSaveedit] = useState(true);
  const [show, setShow] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [senddata, setSenddata] = useState(false);
  const [updatedata, setUpdatedata] = useState(false);
  const [updatedatasuc, setUpdatedatasuc] = useState(false);
  const [docsave, setDocsave] = useState(false);
  const [install_eq, setInstall_eq] = useState("-");
  const [weight, setWeight] = useState(0);
  const [cerf_caat, setCerf_caat] = useState("");
  const [bt_cancel,setBt_cancel] = useState(false)
  const [stdRemoteID, setStdRemoteID] = useState(true);
  const [lastupdate, setLastupdate] = useState(false);
  const [purpose_etc, setPurposeEtc] = useState("");
  const [frequency, setFrequency] = useState({
    checkbox1: 1,
    checkbox2: 0,
    checkbox3: 0,
    checkbox4: 0,
  });
  const [purpose, setPurpose] = useState({
    checkbox1: 1,
    checkbox2: 0,
    checkbox3: 0,
    checkbox4: 0,
    checkbox5: 0,
    checkbox6: 0,
    checkbox7: 0,
    checkbox8: 0,
    checkbox9: 0,
    checkbox10: 0,
    checkbox11: 0,
    checkbox12: 0,
    checkbox13: 0,
  });

  //const [lic_request, setLic_request] = useState();
  const [lic_req_data, setLic_req_data] = useState("");
  const [lic_req_data1, setLic_req_data1] = useState("");
  const [lic_req_data2, setLic_req_data2] = useState("");
  const [remote_sn, setRemote_sn] = useState();
  const [remote_brand, setRemote_brand] = useState();
  const [ins_type, setIns_type] = useState();
  const [ins_number, setIns_number] = useState();
  const [ins_company_name, setIns_company_name] = useState();
  const [ins_limit, setIns_limit] = useState();
  const [ins_limit_dummy, setIns_limit_dummy] = useState("");
  const [ins_start, setIns_start] = useState();
  const [ins_end, setIns_end] = useState();
  const [model, setModel] = useState(); ///mockup
  const [droneserial, setDroneserial] = useState(["-"]); ///mockup
  const [brand, setBrand] = useState(); ///mockup
  const [disabless, setDisabless] = useState(true);
  const [loading, setLoading] = useState(true);
  const [chooselicense, setChooselicense] = useState();
  const [alllicreqdata, setAlllicreqdata] = useState();
  const [dataAccessories, setDataAccessories] = useState(DataAccessories);
  const [open, setOpen] = useState(true);
  const [purposename, setPurposename] = useState([null]);
  const [openpurpose, setOpenpurpose] = useState({
    open1: 0,
    open2: 0,
    open3: 0,
  });
  const [files, setFiles] = useState({
    idcard_file: null,
    homeregis_file: null,
    dronepic_file: null,
    droneserial_file: null,
    remoteserial_file: null,
    selfcert_file: null,
    aircraft_insu_file: null,
    attorney_doc_file: null,
    idcard_attorneyauth_file: null,
    idcard_attorney_file: null,
    legal_result_file: null,
  });
  const [previews, setPreviews] = useState({
    idcard_file: null,
    homeregis_file: null,
    dronepic_file: null,
    droneserial_file: null,
    remoteserial_file: null,
    selfcert_file: null,
    aircraft_insu_file: null,
    attorney_doc_file: null,
    idcard_attorneyauth_file: null,
    idcard_attorney_file: null,
    legal_result_file: null,
  });
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const handleOptionChange = (event) => {
    setChooselicense(event.target.value);
  };
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const value = checked ? 1 : 0;
    setFrequency((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: value,
    }));
  };
  const handleCheckboxpurposeChange = (event) => {
    const { name, checked } = event.target;
    const value = checked ? 1 : 0;
    setPurpose((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: value,
    }));
  };
  const deleteDoc = (drone_id) => {
    AuthServiceV2.removeDrone(drone_id)
      .then((Response) => {
        console.log(Response);
        setshowdelete(false);
        setSenddata(true);
        //Navigate("/statusDrone");
      })
      .catch((error) => {
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      });
  };
  const cancleDrones = () => {
    //drone_id, cert_no, drone_sn, owner_name_drone
    AuthServiceV2.CancelDrone(
      state.drone_id,
      cerf_caat.cert_no,
      droneserial,
      data.f_name + data.l_name,
      cerf_caat.drone_number
    ).then((res) => {
      console.log(res);
      Navigate("/user/drone/statusDrone");
    }).catch((error) => {
      setTextBody(error);
      setModalToggle({ ...modalToggle, modalErr: true });
    });
  };
  function handleFiles(event) {
    console.log(event.target);
    const { id, files } = event.target;
    if (files.length > 0) {
      const file = files[0];
      console.log(file);
      const reader = new FileReader();

      reader.onloadend = () => {
        setPreviews((prevPreviews) => ({
          ...prevPreviews,
          [id]: reader.result, // FileReader result is a data URL
        }));
      };

      reader.readAsDataURL(file);

      setFiles((prevFiles) => ({
        ...prevFiles,
        [id]: file,
      }));
    } else {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [id]: null,
      }));
      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        [id]: null,
      }));
    }
  }
  const getfiletoshow = (path) => {
    const response = AuthServiceV2.Getfile(state.drone_id, path);
    response
      .then((res) => {
        const file = new Blob([res.data], { type: res.data.type });
        const fileUrl = URL.createObjectURL(file);
        //setFileUrl(fileUrl);
        window.open(fileUrl, "_blank");
        // pdfWindow.document.write(
        //   `<iframe src="${fileUrl}" width="100%" height="100%"></iframe>`
        // );
      })
      .catch((error) => {
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      });
  };

  const handleClose = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    setUpdatedatasuc(false);
    setcheckuserdata(false);
    Navigate(state.href);
  };

  const handleSendsuc = () => {
    arrsetstr();
    setDocsave(false);
    setShow(false);
    //setSenddata(true);

    register(false);
  };

  const handleUpdatesuc = (e) => {
    e.preventDefault();
    setUpdatedata(false);
    setUpdatedatasuc(true);
    setDocsave(true);
    register(true);
  };
  const next = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    Navigate(state.href);
  };
  const register = (doc_save) => {
    const lastpurpose = [];
    const allfrequency = [
      frequency.checkbox1,
      frequency.checkbox2,
      frequency.checkbox3,
      frequency.checkbox4,
    ];
    const allpurpose = [
      purpose.checkbox1,
      purpose.checkbox2,
      purpose.checkbox3,
      purpose.checkbox4,
      purpose.checkbox5,
      purpose.checkbox6,
      purpose.checkbox7,
      purpose.checkbox8,
      purpose.checkbox9,
      purpose.checkbox10,
      purpose.checkbox11,
      purpose.checkbox12,
      purpose.checkbox13,
    ];
    for (let i = 0; i <= allpurpose.length; i++) {
      if (allpurpose[i] === 1) {
        lastpurpose.push(i + 1);
      }
    }

    if (parseInt(chooselicense) === 4) {
    } else {
      if (parseInt(chooselicense) === 5) {
        setAlllicreqdata([lic_req_data, lic_req_data1, lic_req_data2]);
      } else {
        console.log(lic_req_data, lic_req_data1);

        setAlllicreqdata([lic_req_data, lic_req_data1]);
      }
    }
    const nonEmptyValues = inputFields
      .filter((field) => field.value !== "")
      .map((field) => field.value);

    const install_eq1 = nonEmptyValues.join(", ");
    const formData = new FormData();
    console.log(
      state.drone_id,
      droneserial,
      brand,
      model,
      install_eq1,
      remote_sn,
      remote_brand,
      stdRemoteID,
      ins_type,
      ins_number,
      ins_company_name,
      ins_limit,
      ins_start,
      ins_end,
      doc_save,
      weight,
      allfrequency,
      allpurpose,
      parseInt(chooselicense),
      alllicreqdata
    );
    if (saveedit === false) {
      for (const [key, value] of Object.entries({
        drone_id: state.drone_id,
        drone_sn: droneserial ? droneserial : null,
        brand: brand ? brand : null,
        model: model ? model : null,
        install_eq: install_eq1 ? install_eq1 : null,
        remote_sn: remote_sn ? remote_sn : null,
        remote_brand: remote_brand ? remote_brand : null,
        built_in_rid: stdRemoteID === true ? 1 : 0,
        weight: weight ? parseFloat(weight).toFixed(5) : null,
        frequency: allfrequency,
        purpose: lastpurpose,
        purpose_etc: purpose_etc,
        lic_request: parseInt(chooselicense),
        lic_req_data: alllicreqdata ? alllicreqdata : null,
        ins_type: ins_type,
        ins_number: ins_number ? ins_number : null,
        ins_company_name: ins_company_name ? ins_company_name : null,
        ins_limit: ins_limit ? ins_limit : null,
        ins_start: ins_start ? ins_start : null,
        ins_end: ins_end ? ins_end : null,
        submit: saveedit === true ? 1 : 0,
      })) {
        if (Array.isArray(value)) {
          console.log(value);
          if (value === null) {
            formData.append(key, null);
          } else {
            formData.append(key, JSON.stringify(value));
          } // Convert arrays to JSON strings
        } else {
          formData.append(key, value);
        }
      }
    } else {
      console.log(typeof allfrequency);
      for (const [key, value] of Object.entries({
        drone_id: state.drone_id,
        drone_sn: droneserial,
        brand: brand,
        model: model,
        install_eq: install_eq1,
        remote_sn: remote_sn,
        remote_brand: remote_brand,
        built_in_rid: stdRemoteID === true ? 1 : 0,
        weight: parseFloat(weight).toFixed(5),
        frequency: allfrequency,
        purpose: lastpurpose,
        purpose_etc: purpose_etc,
        lic_request: parseInt(chooselicense),
        lic_req_data: alllicreqdata,
        ins_type: ins_type,
        ins_number: ins_number,
        ins_company_name: ins_company_name,
        ins_limit: ins_limit,
        ins_start: ins_start,
        ins_end: ins_end,
        submit: saveedit === true ? 1 : 0,
      })) {
        if (Array.isArray(value)) {
          console.log(value);
          if (value === null) {
            formData.append(key, null);
          } else {
            formData.append(key, JSON.stringify(value));
          } // Convert arrays to JSON strings
        } else {
          formData.append(key, value);
        }
      }
    }

    // Append files
    for (const [key, file] of Object.entries(files)) {
      if (file) {
        formData.append(key, file);
      }
    }
    if (saveedit === false) {
      // AuthServiceV2.UpdateDroneReturnWithRegulator(
      //   state.drone_id,
      //   droneserial ? droneserial : "-",
      //   brand ? brand : "-",
      //   model ? model : "-",
      //   install_eq1 ? install_eq1 : "-",
      //   remote_sn ? remote_sn : "-",
      //   remote_brand ? remote_brand : "-",
      //   stdRemoteID,
      //   weight,
      //   allfrequency,
      //   allpurpose,
      //   parseInt(chooselicense),
      //   alllicreqdata ? alllicreqdata : ["-"],
      //   ins_type,
      //   ins_number ? ins_number : "-",
      //   ins_company_name ? ins_company_name : "-",
      //   ins_limit ? ins_limit : 0,
      //   ins_start ? ins_start : "2023-08-15",
      //   ins_end ? ins_end : "2024-08-15",
      //   saveedit
      // )
      AuthServiceV2.UpdateDroneReturnWithRegulator(formData)
        .then((Response) => {
          console.log(Response);
          setSenddata(true);
          //Navigate("/statusDrone");
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    } else {
      // AuthServiceV2.UpdateDroneReturnWithRegulator(
      //   state.drone_id,
      //   droneserial,
      //   brand,
      //   model,
      //   install_eq1,
      //   remote_sn,
      //   remote_brand,
      //   stdRemoteID,
      //   weight,
      //   allfrequency,
      //   allpurpose,
      //   parseInt(chooselicense),
      //   [lic_req_data, lic_req_data1],
      //   ins_type,
      //   ins_number,
      //   ins_company_name,
      //   ins_limit,
      //   ins_start,
      //   ins_end,
      //   saveedit
      // )
      AuthServiceV2.UpdateDroneReturnWithRegulator(formData)
        .then((Response) => {
          console.log(Response);
          setSenddata(true);
          //Navigate("/statusDrone");
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const getpurpost = () => {
    const check = AuthServiceV2.DronePurposes();
    if (check != null) {
      check
        .then((res) => {
          setPurposename(res.data.data);
          console.log(res.data.data);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  useEffect(() => {
    getpurpost();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (state != null) {
        await getOnlyOneDroneData(state);
        console.log("Status:", state);
      } else {
        await getOnlyOneDroneData(prop);
      }
    };

    fetchData();
  }, [prop, state]);

  const getOnlyOneDroneData = (data) => {
    const check = AuthServiceV2.getonedatadrone(data.drone_id);
    if (check != null) {
      check
        .then((res) => {
          const datas = res.data.drone_data;
          console.log(datas);
          if (datas.built_in_rid === 1) {
            setStdRemoteID(true);
          } else {
            setStdRemoteID(false);
          }
          setCerf_caat(datas.caat_register);
          setDroneserial(datas.drone_serial_number);
          setBrand(datas.drone_brand);
          setModel(datas.drone_model);
          revert_ins_acc(datas.install_eq);
          setRemote_brand(datas.controller_brand);
          setRemote_sn(datas.controller_serial_number);
          setWeight(parseFloat(datas.weight));
          setIns_type(datas.ins_type);
          setIns_number(datas.ins_number);
          setIns_company_name(datas.ins_company_name);
          setIns_limit(datas.ins_limit);
          setIns_start(datas.ins_start);
          setIns_end(datas.ins_end);
          console.log(ins_end);
          setFrequency({
            checkbox1: datas.frequency[0],
            checkbox2: datas.frequency[1],
            checkbox3: datas.frequency[2],
            checkbox4: datas.frequency[3],
          });

          setFiles({
            idcard_file: datas.files.idcard_file,
            homeregis_file: datas.files.homeregis_file,
            dronepic_file: datas.files.dronepic_file,
            droneserial_file: datas.files.droneserial_file,
            remoteserial_file: datas.files.remoteserial_file,
            selfcert_file: datas.files.selfcert_file,
            aircraft_insu_file: datas.files.aircraftinsu_file,
            attorney_doc_file: datas.files.attorneydoc_file,
            idcard_attorneyauth_file: datas.files.idcardauth_file,
            idcard_attorney_file: datas.files.idcardattorney_file,
            legal_result_file: datas.files.legalresult_file,
          });
          setPreviews({
            idcard_file: datas.files.idcard_file,
            homeregis_file: datas.files.homeregis_file,
            dronepic_file: datas.files.dronepic_file,
            droneserial_file: datas.files.droneserial_file,
            remoteserial_file: datas.files.remoteserial_file,
            selfcert_file: datas.files.selfcert_file,
            aircraft_insu_file: datas.files.aircraftinsu_file,
            attorney_doc_file: datas.files.attorneydoc_file,
            idcard_attorneyauth_file: datas.files.idcardauth_file,
            idcard_attorney_file: datas.files.idcardattorney_file,
            legal_result_file: datas.files.legalresult_file,
          });
          //setPurpose(datas.purpose)
          let temppur = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          for (let i = 0; i <= 13; i++) {
            if (datas.purpose[i] === 1) {
              temppur[0] = 1;
            } else if (datas.purpose[i] === 2) {
              console.log(2);
              temppur[1] = 1;
            } else if (datas.purpose[i] === 3) {
              temppur[2] = 1;
            } else if (datas.purpose[i] === 4) {
              temppur[3] = 1;
            } else if (datas.purpose[i] === 5) {
              temppur[4] = 1;
            } else if (datas.purpose[i] === 6) {
              temppur[5] = 1;
            } else if (datas.purpose[i] === 7) {
              temppur[6] = 1;
            } else if (datas.purpose[i] === 8) {
              temppur[7] = 1;
            } else if (datas.purpose[i] === 9) {
              temppur[8] = 1;
            } else if (datas.purpose[i] === 10) {
              temppur[9] = 1;
            } else if (datas.purpose[i] === 11) {
              temppur[10] = 1;
            } else if (datas.purpose[i] === 12) {
              temppur[11] = 1;
            } else if (datas.purpose[i] === 13) {
              temppur[12] = 1;
            }
          }
          console.log(temppur[6]);
          if (temppur[6] === 1) {
            console.log("sddfgfgd");
            setOpenpurpose({
              open2: 1,
            });
          }
          setPurpose({
            checkbox1: temppur[0],
            checkbox2: temppur[1],
            checkbox3: temppur[2],
            checkbox4: temppur[3],
            checkbox5: temppur[4],
            checkbox6: temppur[5],
            checkbox7: temppur[6],
            checkbox8: temppur[7],
            checkbox9: temppur[8],
            checkbox10: temppur[9],
            checkbox11: temppur[10],
            checkbox12: temppur[11],
            checkbox13: temppur[12],
          });
          if (temppur[4] === 1 || temppur[5] === 1) {
            setOpenpurpose((prevCheckboxes) => ({
              ...prevCheckboxes,
              open1: 1,
            }));
          }
          if (temppur[6] === 1) {
            setOpenpurpose((prevCheckboxes) => ({
              ...prevCheckboxes,
              open2: 1,
            }));
          }
          setPurposeEtc(datas.purpose_etc);
          setChooselicense(datas.lic_request.toString());
          //console.log(res.data.drone_data);
          if (datas.lic_req_data.length === 1) {
            setLic_req_data(datas.lic_req_data[0]);
          }
          if (datas.lic_req_data.length === 2) {
            //console.log("sdsd");

            setLic_req_data(datas.lic_req_data[0]);
            setLic_req_data1(datas.lic_req_data[1]);
          }
          if (datas.lic_req_data.length === 3) {
            setLic_req_data(datas.lic_req_data[0]);
            setLic_req_data1(datas.lic_req_data[1]);
            setLic_req_data2(datas.lic_req_data[2]);
          }

          //setDataEdit(res.data.drone_data);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } else {
      alert("ไม่พบ Remote ID  ที่ค้นหา");
    }
  };

  useEffect(() => {
    const checktype = sessionStorage.getItem("type_user");
    if (checktype === "corporation") {
      const checkcorpertation = AuthServiceV2.corporationdata();
      if (checkcorpertation != null) {
        checkcorpertation
          .then(function (result) {
            setData(result.data.data);
            console.log(result);
          })
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });
          });
      }
    } else {
      const check = AuthServiceV2.getCurrentUser();
      if (check != null)
        check
          .then(function (result) {
            //console.log(result);
            if (result.data.data.address != null) {
              //console.log("passPIS");

              const data1 = AuthServiceV2.getCurrentUser()
                .then(function (result) {
                  setData(result.data.data);
                  //console.log(result);
                })
                .catch((error) => {
                  setTextBody(error);
                  setModalToggle({ ...modalToggle, modalErr: true });
                });
            } else {
              console.log("passGDSNS");
              setcheckuserdata(true);
              setTimeout((e) => {
                setcheckuserdata(false);
                editdrone();
                //Navigate("/profile/editprofileuser");
              }, 3000);

              const data1 = AuthServiceV2.getCurrentUser()
                .then(function (result) {
                  setData(result.data.data);
                  //console.log(result)
                })
                .catch((error) => {
                  setTextBody(error);
                  setModalToggle({ ...modalToggle, modalErr: true });
                });
            }
            console.log(chooselicense);
          })
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });
          });
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidated(true);
    console.log(form1.current.checkValidity());
    if (form1.current.checkValidity() === true) {
      setShow(true);
    }
  };

  const revert_ins_acc = (acc) => {
    console.log(acc);
    if (acc === "-") {
      //setInstall_eq(["-"]);
    } else {
      const revert_acc_arr = acc.split(",").map(Number);
      console.log(revert_acc_arr);
      const selectedAccessories = revert_acc_arr.map(
        (num) =>
          DataAccessories.find((item) => parseInt(item.id) === num).selection
      );
      console.log(selectedAccessories);
      setInstall_eq(selectedAccessories);
    }
  };

  const formatCurrency = (value) => {
    const formattedPrice = new Intl.NumberFormat("th-TH", {
      maximumSignificantDigits: 3,
      style: "currency",
      currency: "THB",
    }).format(value);

    return formattedPrice;
  };
  const [inputFields, setInputFields] = useState([{ id: 1, value: "" }]);
  const [addfield, setAddfield] = useState(false);

  const handleInputChange = (num_id, inputvalue) => {
    console.log(num_id, inputvalue);
    const updatedFields = inputFields.map((field) =>
      field.id === num_id ? { ...field, value: inputvalue } : field
    );

    //console.log(dataAccessories);
    // const updateAccessories = dataAccessories.filter(
    //   (field) => field.id !== inputvalue
    // );
    // console.log( inputFields);
    // console.log(updateAccessories , dataAccessories)
    // console.log(DataAccessories);
    // setDataAccessories(updateAccessories);
    setInputFields(updatedFields);
    if (num_id >= inputFields.length) {
      setAddfield(true);
    }
  };
  const handleRemoveField = (id) => {
    if (id > 1) {
      setInputFields(inputFields.filter((field) => field.id !== id));
    } else {
      setInputFields([{ id: 1, value: "" }]);
    }
  };
  const arrsetstr = () => {
    const nonEmptyValues = inputFields
      .filter((field) => field.value !== "")
      .map((field) => field.value);

    const install_eq1 = nonEmptyValues.join(", ");
    console.log(install_eq1);
    setInstall_eq(install_eq1);
  };
  useEffect(() => {
    if (addfield === true) {
      if (inputFields.length !== 11) {
        setInputFields([
          ...inputFields,
          { id: inputFields[inputFields.length - 1].id + 1, value: "" },
        ]);
        setAddfield(false);
      }
    }
  }, [addfield]);
  const handleInputCurrency = (e) => {
    const enteredValue = e.target.value;
    const numericValue = parseInt(enteredValue.replace(/[^\d]/g, ""));
    setIns_limit(numericValue);
    if (!isNaN(numericValue)) {
      const formattedValue = formatCurrency(numericValue);
      setIns_limit_dummy(formattedValue);
    } else {
      setIns_limit_dummy("");
    }
  };
  useEffect(() => {
    if (!isNaN(ins_limit)) {
      const formattedValue = formatCurrency(ins_limit);
      setIns_limit_dummy(formattedValue);
    } else {
      setIns_limit_dummy("");
    }
  }, [ins_limit]);
  const handleback = () => {
    console.log(state);
    Navigate(state.href);
  };
  return (
    <div>
      <div className="container-main" style={{ color: "black" }}>
        <div>
          {loading === true ? (
            <div className="form-section">
              <div className="loading-container" style={{ height: "20vh" }}>
                {" "}
                <Spinner animation="border" variant="secondary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            </div>
          ) : (
            <>
              <div className="form-section">
                <div style={{ display: "flex" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ArrowBackIosNewOutlinedIcon
                      onClick={handleback}
                      style={{ cursor: "pointer", display: "flex" }}
                    />
                  </div>
                  {cerf_caat !== undefined ? (
                    <>
                      {cerf_caat.status === "ยกเลิกการลงทะเบียน" ? (
                        <div
                          className="grid-item"
                          style={{ display: "block", marginLeft: "auto" }}
                        >
                          <div style={{ color: "red" }}>
                            เอกสารยกเลิกการขึ้นทะเบียน
                          </div>
                          <div style={{ width: "200px", border: "solid 1px" }}>
                            <a
                              href={cerf_caat.cert_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Click Link
                            </a>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {cerf_caat.status === "ไม่อนุมัติ" ? (
                        <div
                          className="grid-item"
                          style={{ display: "block", marginLeft: "auto" }}
                        >
                          <div style={{ color: "red" }}>
                            เหตุผลที่ไม่อนุมัติ
                          </div>
                          <div style={{ width: "200px", border: "solid 1px" }}>
                            <a
                              //href={cerf_caat.cert_url}
                              //target="_blank"
                              rel="noopener noreferrer"
                            >
                              {cerf_caat.message}
                            </a>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {state.status === "อนุมัติ" &&
                  cerf_caat.status === "อนุมัติ" ? (
                    <div
                      className="grid-item"
                      style={{ display: "flex", marginLeft: "auto" }}
                    >
                      <button
                        style={{
                          width: "200px",
                          height: "50px",
                          fontSize: "18px",
                          backgroundColor: "red",
                          border: "0px",
                          borderRadius: "100px",
                          color: "white",
                          background:
                            "linear-gradient(27deg, rgba(255,0,0,1) 0%, rgba(222,0,0,1) 30%, rgba(171,0,0,1) 60%, rgba(85,45,0,1) 100%)",
                        }}
                        onClick={() => {
                          setBt_cancel(true)
                          
                        }}
                      >
                        ยกเลิกเอกสาร Drone
                      </button>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <div
                          className="grid-item"
                          style={{ display: "block", marginLeft: "auto" }}
                        >
                          <div style={{ color: "red" }}>
                            เอกสารยืนยันการขึ้นทะเบียน
                          </div>
                          <div style={{ width: "200px", border: "solid 1px" }}>
                            <a
                              href={cerf_caat.cert_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {cerf_caat.cert_url ? "Click Link":"ไม่มีเอกสาร"}
                            </a>
                          </div>
                        </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {open && state.status === "ตรวจสอบเอกสาร" ? (
                    <div
                      className="grid-item"
                      style={{ display: "flex", marginLeft: "auto" }}
                    >
                      <button
                        style={{
                          width: "200px",
                          height: "50px",
                          fontSize: "18px",
                          backgroundColor: "red",
                          border: "0px",
                          borderRadius: "100px",
                          color: "white",
                          background:
                            "linear-gradient(27deg, rgba(255,0,0,1) 0%, rgba(222,0,0,1) 30%, rgba(171,0,0,1) 60%, rgba(85,45,0,1) 100%)",
                        }}
                      >
                        ยกเลิกคำขออนุมัติ
                      </button>
                    </div>
                  ) : null}

                  {open &&
                  (state.status === "รอแก้ไข" ||
                    state.status === "ร่างเอกสาร") ? (
                    <div
                      className="grid-item"
                      style={{ display: "flex", marginLeft: "auto" }}
                    >
                      {open && state.status === "ร่างเอกสาร" ? (
                        <button
                          className="custom-btn btnCancel"
                          style={{
                            width: "200px",
                            height: "50px",
                            fontSize: "18px",
                            backgroundColor: "red",
                            border: "0px",
                            borderRadius: "100px",
                            color: "white",
                            background:
                              "linear-gradient(27deg, rgba(255,0,0,1) 0%, rgba(222,0,0,1) 30%, rgba(171,0,0,1) 60%, rgba(85,45,0,1) 100%)",
                          }}
                          onClick={() => setshowdelete(true)}
                        >
                          ลบเอกสาร
                        </button>
                      ) : null}
                      <button
                        className="custom-btn btnEdit2"
                        style={{
                          width: "200px",
                          height: "50px",
                          fontSize: "18px",
                        }}
                        onClick={() => setOpen(false)}
                      >
                        แก้ไขข้อมูล
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                  <>
                    {!open &&
                    (state.status === "รอแก้ไข" ||
                      state.status === "ร่างเอกสาร") &&
                    state.caatcom != null &&
                    state.nbtccom != null ? (
                      <>
                        <div
                          className="grid-item"
                          style={{
                            display: "flex",
                            marginLeft: "auto",
                            display: "block",
                          }}
                        >
                          <div style={{ color: "red", fontSize: "18px" }}>
                            สิ่งที่ต้องแก้ไข
                          </div>
                          <div>
                            <div
                              disabled
                              style={{
                                height: "50px",
                                width: "200px",
                                border: "solid 1px",
                                borderWidth: "1px",
                                borderRadius: "10px",
                                display: "block",
                              }}
                            >
                              {state.caatcom}/{state.nbtccom}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {!open && state.caatcom !== null ? (
                          <div
                            className="grid-item"
                            style={{
                              display: "flex",
                              marginLeft: "auto",
                              display: "block",
                            }}
                          >
                            <div style={{ color: "red", fontSize: "18px" }}>
                              สิ่งที่ต้องแก้ไข
                            </div>
                            <div>
                              <div
                                disabled
                                style={{
                                  height: "50px",
                                  width: "200px",
                                  border: "solid 1px",
                                  borderWidth: "1px",
                                  borderRadius: "10px",
                                  display: "block",
                                }}
                              >
                                {state.caatcom}
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {!open && state.nbtccom !== null ? (
                          <div
                            className="grid-item"
                            style={{
                              display: "flex",
                              marginLeft: "auto",
                              display: "block",
                            }}
                          >
                            <div style={{ color: "red", fontSize: "18px" }}>
                              สิ่งที่ต้องแก้ไข
                            </div>
                            <div>
                              <div
                                disabled
                                style={{
                                  height: "50px",
                                  width: "200px",
                                  border: "solid 1px",
                                  borderWidth: "1px",
                                  borderRadius: "10px",
                                  display: "block",
                                }}
                              >
                                {state.nbtccom}
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </>
                </div>
                <Form
                  ref={form1}
                  noValidate
                  validated={validated}
                  onSubmit={(e) => handleSubmit(e)}
                >
                  <Row className="mb-3 row-main">
                    <Form.Label>
                      {" "}
                      <h2 className="header-main">
                        ขอใบขึ้นทะเบียนเครื่องวิทยุคมนาคม
                      </h2>
                    </Form.Label>
                    <Form.Label>
                      {" "}
                      <h3 as={Col} className="header-main">
                        ข้อมูลอากาศยานที่ควบคุมการบินจากภายนอก
                      </h3>
                    </Form.Label>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        Serial Number<span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        disabled={open}
                        required
                        type="text"
                        placeholder="กรอกเลข serial number"
                        className="form-input"
                        value={droneserial}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        ตราอักษร<span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        disabled={open}
                        required
                        type="text"
                        placeholder="ตราอักษร"
                        className="form-input"
                        value={brand}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        รุ่น<span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        disabled={open}
                        required
                        type="text"
                        placeholder="รุ่น"
                        className="form-input"
                        value={model}
                      />
                    </Form.Group>
                    {!open ? (
                      ""
                    ) : (
                      <>
                        {install_eq !== "-" ? (
                          <Form.Group as={Col} md="6">
                            <Form.Label className="font-cen">
                              อุปกรณ์ที่ติดตั้ง(ถ้ามีโปรดระบุ)/installed
                              accessories
                            </Form.Label>
                            {install_eq.map((field, index) => (
                              <div key={field.id}>
                                <Form.Control
                                  className="form-input"
                                  disabled
                                  value={index + 1 + ". " + field}
                                />
                              </div>
                            ))}
                          </Form.Group>
                        ) : (
                          <Form.Group as={Col} md="6">
                            <Form.Label className="font-cen">
                              อุปกรณ์ที่ติดตั้ง(ถ้ามีโปรดระบุ)/installed
                              accessories
                            </Form.Label>
                            <Form.Control
                              className="form-input"
                              disabled
                              value={install_eq}
                            />
                          </Form.Group>
                        )}
                      </>
                    )}
                    {!open ? (
                      <>
                        {inputFields.length === 1 ? (
                          <Form.Group as={Col} md="6">
                            <Form.Label className="font-cen">
                              อุปกรณ์ที่ติดตั้ง(ถ้ามีโปรดระบุ)/installed
                              accessories
                            </Form.Label>
                            {inputFields.map((field) => (
                              <div key={field.id} style={{ display: "flex" }}>
                                <Form.Select
                                  className="form-selection"
                                  value={field.value}
                                  onChange={(e) =>
                                    handleInputChange(field.id, e.target.value)
                                  }
                                >
                                  {dataAccessories.map((dataAcc) => (
                                    <option value={dataAcc.id}>
                                      {dataAcc.selection}
                                    </option>
                                  ))}
                                </Form.Select>
                                <button
                                  className="btn-Delselection"
                                  onClick={() => handleRemoveField(field.id)}
                                ></button>
                              </div>
                            ))}
                            <p className="text-description">
                              (เป็นอุปรณ์ที่นำมาติดตั้งเพิ่มเติม
                              ที่ไม่ได้มาจากโรงงาน)
                            </p>
                          </Form.Group>
                        ) : (
                          <Form.Group as={Col} md="6">
                            <Form.Label className="font-cen">
                              อุปกรณ์ที่ติดตั้ง(ถ้ามีโปรดระบุ)/installed
                              accessories
                            </Form.Label>
                            {inputFields.map((field) => (
                              <div
                                key={field.id}
                                style={{ padding: "2px", display: "flex" }}
                              >
                                <Form.Select
                                  className="form-selection"
                                  value={field.value}
                                  onChange={(e) =>
                                    handleInputChange(field.id, e.target.value)
                                  }
                                >
                                  {dataAccessories.map((dataAcc) => (
                                    <option value={dataAcc.id}>
                                      {dataAcc.selection}
                                    </option>
                                  ))}
                                </Form.Select>
                                <button
                                  className="btn-Delselection"
                                  onClick={() => handleRemoveField(field.id)}
                                ></button>
                              </div>
                            ))}
                          </Form.Group>
                        )}
                      </>
                    ) : (
                      ""
                    )}

                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        น้ำหนัก<span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <div>
                        <Form.Control
                          disabled={open}
                          required
                          id="weight"
                          type="text"
                          placeholder="น้ำหนัก"
                          className="form-input"
                          value={weight}
                          pattern="^\d*\.?\d*$"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                              if (value < 2) {
                                setPurpose({
                                  checkbox1: 1,
                                  checkbox2: 0,
                                  checkbox3: 0,
                                  checkbox4: 0,
                                  checkbox5: 0,
                                  checkbox6: 0,
                                  checkbox7: 0,
                                  checkbox8: 0,
                                  checkbox9: 0,
                                  checkbox10: 0,
                                  checkbox11: 0,
                                  checkbox12: 0,
                                  checkbox13: 0,
                                });
                              }
                              setWeight(value);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault(); // Prevents the default "Enter" key behavior
                            }
                          }}
                        />
                      </div>
                    </Form.Group>

                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        มี Standard Remote ID
                        <span style={{ color: "red" }}></span>
                      </Form.Label>
                      <div>
                        <Form.Label className="font-cen">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="standardRemoteID"
                            value="0"
                            checked={stdRemoteID === false}
                            onChange={() => {
                              if (stdRemoteID === false) {
                                setStdRemoteID(true);
                              } else {
                                setStdRemoteID(false);
                              }
                            }}
                          />
                          &nbsp;"มี Standard Remote ID"
                        </Form.Label>
                      </div>
                    </Form.Group>

                    <div className="card-main" style={{ height: "auto" }}>
                      <div style={{ display: "block" }}>
                        <Form.Label className="font-cen">
                          คลื่นความถี่ (MHz)
                          และกำลังส่งออกอากาศสมมูลแบบไอโซทรอปิก
                          <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox1"
                            value="1"
                            checked={frequency.checkbox1 === 1}
                            onChange={handleCheckboxChange}
                          />
                          &nbsp;433.05 – 434.79 MHz กำลังส่งสูงสุด e.i.r.p. 10
                          mW
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox2"
                            value="2"
                            checked={frequency.checkbox2 === 1}
                            onChange={handleCheckboxChange}
                          />
                          &nbsp;2400 – 2500 MHz กำลังส่งสูงสุด e.i.r.p. 100 mW
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox3"
                            value="3"
                            checked={frequency.checkbox3 === 1}
                            onChange={handleCheckboxChange}
                          />
                          &nbsp;5725 – 5850 MHz กำลังส่งสูงสุด e.i.r.p. 1000 mW
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox4"
                            value="4"
                            checked={frequency.checkbox4 === 1}
                            onChange={handleCheckboxChange}
                          />
                          &nbsp;24.05 – 24.25 GHz กำลังส่งสูงสุด e.i.r.p. 100 mW
                        </Form.Label>
                      </div>
                    </div>
                    <hr />
                    <div className="card-main" style={{ height: "auto" }}>
                      <div style={{ display: "block" }}>
                        <Form.Label
                          className="font-cen"
                          style={{ marginBottom: "-6.5px" }}
                        >
                          วัตถุประสงค์ของการใช้อากาศยาน aircraft.
                          <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <p className="text-description">
                          (สามารถเลือกได้มากกว่า 1 ข้อ)
                        </p>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox1"
                            value={parseInt(0)}
                            checked={purpose.checkbox1 === 1}
                            onChange={handleCheckboxpurposeChange}
                          />
                          &nbsp;
                          {purposename[0] != null ? purposename[0].purpose : ""}
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            type="checkbox"
                            name="checkbox2"
                            value={parseInt(0)}
                            checked={purpose.checkbox2 === 1}
                            onChange={handleCheckboxpurposeChange}
                            disabled={
                              sessionStorage.getItem("type_user") === "user" ||
                              open
                                ? true
                                : false
                            }
                          />
                          &nbsp;
                          {purposename[1] != null ? purposename[1].purpose : ""}
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox3"
                            value={parseInt(0)}
                            checked={purpose.checkbox3 === 1}
                            onChange={handleCheckboxpurposeChange}
                            //disabled={weight < 2 ? true : false}
                          />
                          &nbsp;
                          {purposename[2] != null ? purposename[2].purpose : ""}
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox4"
                            value={parseInt(0)}
                            checked={purpose.checkbox4 === 1}
                            onChange={handleCheckboxpurposeChange}
                            //disabled={weight < 2 ? true : false}
                          />
                          &nbsp;
                          {purposename[3] != null ? purposename[3].purpose : ""}
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            type="checkbox"
                            name="gh"
                            value={parseInt(0)}
                            checked={openpurpose.open1 === 1}
                            onChange={() => {
                              if (openpurpose.open1 != 1) {
                                setOpenpurpose((prevCheckboxes) => ({
                                  ...prevCheckboxes,
                                  open1: 1,
                                }));
                              } else {
                                setOpenpurpose((prevCheckboxes) => ({
                                  ...prevCheckboxes,
                                  open1: 0,
                                }));
                                setPurpose((prevCheckboxes) => ({
                                  ...prevCheckboxes,
                                  checkbox5: 0,
                                  checkbox6: 0,
                                }));
                              }
                            }}
                            disabled={
                              sessionStorage.getItem("type_user") === "user" ||
                              open
                                ? true
                                : false
                            }
                          />
                          &nbsp;เพื่อการวิจัย
                        </Form.Label>
                        {openpurpose.open1 === 1 ? (
                          <>
                            <Form.Label
                              className="font-censize"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                type="checkbox"
                                name="checkbox5"
                                value={parseInt(0)}
                                checked={purpose.checkbox5 === 1}
                                onChange={handleCheckboxpurposeChange}
                                disabled={weight < 2 ? true : false}
                              />
                              &nbsp;
                              {purposename[4] != null
                                ? purposename[4].purpose
                                : ""}
                            </Form.Label>
                            <Form.Label
                              className="font-censize"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                type="checkbox"
                                name="checkbox6"
                                value={parseInt(0)}
                                checked={purpose.checkbox6 === 1}
                                onChange={handleCheckboxpurposeChange}
                                disabled={weight < 2 ? true : false}
                              />
                              &nbsp;
                              {purposename[5] != null
                                ? purposename[5].purpose
                                : ""}
                            </Form.Label>
                          </>
                        ) : (
                          ""
                        )}
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="open2"
                            value={parseInt(0)}
                            checked={openpurpose.open2 === 1}
                            onChange={() => {
                              if (openpurpose.open2 != 1) {
                                setOpenpurpose((prevCheckboxes) => ({
                                  ...prevCheckboxes,
                                  open2: 1,
                                }));
                                setPurpose((prevCheckboxes) => ({
                                  ...prevCheckboxes,
                                  checkbox7: 1,
                                }));
                              } else {
                                setOpenpurpose((prevCheckboxes) => ({
                                  ...prevCheckboxes,
                                  open2: 0,
                                }));
                                setPurpose((prevCheckboxes) => ({
                                  ...prevCheckboxes,
                                  checkbox8: 0,
                                  checkbox9: 0,
                                  checkbox10: 0,
                                  checkbox11: 0,
                                  checkbox12: 0,
                                  checkbox13: 0,
                                }));
                              }
                            }}
                            //disabled={weight < 2 ? true : false}
                          />
                          &nbsp;
                          {purposename[6] != null ? purposename[6].purpose : ""}
                        </Form.Label>
                        {openpurpose.open2 === 1 ? (
                          <>
                            <Form.Label
                              className="font-censize"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                disabled={open}
                                type="checkbox"
                                name="checkbox8"
                                value={parseInt(0)}
                                checked={purpose.checkbox8 === 1}
                                onChange={handleCheckboxpurposeChange}
                                //disabled={weight < 2 ? true : false}
                              />
                              &nbsp;
                              {purposename[7] != null
                                ? purposename[7].purpose
                                : ""}
                            </Form.Label>
                            <Form.Label
                              className="font-censize"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                disabled={open}
                                type="checkbox"
                                name="checkbox9"
                                value={parseInt(0)}
                                checked={purpose.checkbox9 === 1}
                                onChange={handleCheckboxpurposeChange}
                                //disabled={weight < 2 ? true : false}
                              />
                              &nbsp;
                              {purposename[8] != null
                                ? purposename[8].purpose
                                : ""}
                            </Form.Label>
                            <Form.Label
                              className="font-censize"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                disabled={open}
                                type="checkbox"
                                name="checkbox10"
                                value={parseInt(0)}
                                checked={purpose.checkbox10 === 1}
                                onChange={handleCheckboxpurposeChange}
                                //disabled={weight < 2 ? true : false}
                              />
                              &nbsp;
                              {purposename[9] != null
                                ? purposename[9].purpose
                                : ""}
                            </Form.Label>
                            <Form.Label
                              className="font-censize"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                disabled={open}
                                type="checkbox"
                                name="checkbox11"
                                value={parseInt(0)}
                                checked={purpose.checkbox11 === 1}
                                onChange={handleCheckboxpurposeChange}
                                //disabled={weight < 2 ? true : false}
                              />
                              &nbsp;
                              {purposename[10] != null
                                ? purposename[10].purpose
                                : ""}
                            </Form.Label>
                            <Form.Label
                              className="font-censize"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                disabled={open}
                                type="checkbox"
                                name="checkbox12"
                                value={parseInt(0)}
                                checked={purpose.checkbox12 === 1}
                                onChange={handleCheckboxpurposeChange}
                                //disabled={weight < 2 ? true : false}
                              />
                              &nbsp;
                              {purposename[11] != null
                                ? purposename[11].purpose
                                : ""}
                            </Form.Label>
                            <Form.Label
                              className="font-censize"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                disabled={open}
                                type="checkbox"
                                name="checkbox13"
                                value={parseInt(0)}
                                checked={purpose.checkbox13 === 1}
                                onChange={handleCheckboxpurposeChange}
                                //disabled={weight < 2 ? true : false}
                              />
                              &nbsp;
                              {purposename[12] != null
                                ? purposename[12].purpose
                                : ""}
                            </Form.Label>

                            <Form.Label
                              className="font-censize"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                type="checkbox"
                                name="checkbox7"
                                value={parseInt(0)}
                                checked={purpose.checkbox7 === 1}
                                onChange={handleCheckboxpurposeChange}
                                disabled={open}
                              />
                              อื่นๆโปรดระบุ &nbsp;
                              <input
                                disabled={open}
                                type="text"
                                name="input"
                                value={purpose_etc}
                                onChange={(e) => setPurposeEtc(e.target.value)}
                                style={{ width: "400px" }}
                              />
                              &nbsp;
                            </Form.Label>
                          </>
                        ) : (
                          ""
                        )}
                        {/* <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox1"
                            value={parseInt(0)}
                            checked={purpose.checkbox1 === 1}
                            onChange={handleCheckboxpurposeChange}
                          />
                          &nbsp; เพื่อการเล่นเป็นงานอดิเรก ความบันเทิง หรือ
                          เพื่อการกีฬา
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox2"
                            value={parseInt(0)}
                            checked={purpose.checkbox2 === 1}
                            onChange={handleCheckboxpurposeChange}
                          />
                          &nbsp;เพื่อการรายงานเหตุการณ์หรือรายงานจราจร
                          (สื่อมวลชน)
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox3"
                            value={parseInt(0)}
                            checked={purpose.checkbox3 === 1}
                            onChange={handleCheckboxpurposeChange}
                          />
                          &nbsp;เพื่อการวิจัย ทดลอง ทดสอบ ตามประกาศ กสทช.
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox4"
                            value={parseInt(0)}
                            checked={purpose.checkbox4 === 1}
                            onChange={handleCheckboxpurposeChange}
                          />
                          &nbsp;เพื่อการวิจัยและพัฒนาอากาศยาน เพื่อการพาณิชย์
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox5"
                            value={parseInt(0)}
                            checked={purpose.checkbox5 === 1}
                            onChange={handleCheckboxpurposeChange}
                          />
                          &nbsp;เพื่อการถ่ายภาพ
                          ถ่ายทำหรือการแสดงในภาพยนต์หรือรายการโทรทัศน์
                        </Form.Label>
                        <Form.Label className="font-censize">
                          <input
                            disabled={open}
                            type="checkbox"
                            name="checkbox6"
                            value={parseInt(0)}
                            checked={purpose.checkbox6 === 1}
                            onChange={handleCheckboxpurposeChange}
                          />
                          &nbsp;เพื่อสำรวจสิ่งปลูกสร้าง
                        </Form.Label> */}
                        {/* <Form.Label className="font-censize">
                        <input
                          type="checkbox"
                          name="checkbox7"
                          value={parseInt(0)}
                          checked={purpose.checkbox7 === 1}
                          onChange={handleCheckboxpurposeChange}
                        />
                        &nbsp;กรณีมีวัตถุประสงค์อื่น ให้ระบุ
                      </Form.Label> */}
                        {/* {purpose.checkbox7 === 1 && (
                        <Form.Label className="font-censize">
                          <input
                            type="text"
                            name="input"
                            value={purposecomment}
                            checked={purpose.checkbox7 === 1}
                            onChange={(e) => setPurposecomment(e.target.value)}
                            style={{ width: "400px" }}
                          />
                          &nbsp;
                        </Form.Label>
                      )} */}
                      </div>
                    </div>
                  </Row>
                  <Row className="mb-3 row-main" style={{ marginTop: "35px" }}>
                    <Form.Label>
                      {" "}
                      <h3
                        as={Col}
                        style={{
                          color: "#0077B6",
                          fontStyle: "normal",
                          fontSize: "39px",
                        }}
                      >
                        ข้อมูลอุปกรณ์ควบคุมการบิน
                      </h3>
                    </Form.Label>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        แบรนด์อุปกรณ์ควบคุมการบิน
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        disabled={open}
                        required
                        id="remote_brand"
                        type="text"
                        pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                        maxLength={50}
                        className="form-input"
                        value={remote_brand}
                        onChange={(e) => {
                          setRemote_brand(e.target.value);
                        }}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        หมายเลขประจำเครื่องอุปกรณ์ควบคุมการบิน
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        disabled={open}
                        required
                        id="remote_sn"
                        type="text"
                        pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                        maxLength={50}
                        className="form-input"
                        value={remote_sn}
                        onChange={(e) => {
                          setRemote_sn(e.target.value);
                        }}
                      />
                    </Form.Group>
                  </Row>
                  <Row className="mb-3 row-main" style={{ marginTop: "35px" }}>
                    <Form.Label>
                      <h3
                        as={Col}
                        style={{
                          color: "#0077B6",
                          fontStyle: "normal",
                          fontSize: "39px",
                        }}
                      >
                        เอกสารการประกันภัย
                      </h3>
                    </Form.Label>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        ประเภทกรมธรรม์<span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        disabled
                        required
                        type="text"
                        placeholder=""
                        //disabled
                        className="form-input"
                        value={ins_type}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        เลขกรมธรรม์<span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_number"
                        type="text"
                        pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                        maxLength={50}
                        disabled={open}
                        className="form-input"
                        value={ins_number}
                        onChange={(e) => {
                          setIns_number(e.target.value);
                        }}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        ชื่อบริษัทประกัน<span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_company_name"
                        type="text"
                        placeholder=""
                        disabled={open}
                        className="form-input"
                        value={ins_company_name}
                        onChange={(e) => {
                          setIns_company_name(e.target.value);
                        }}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        วงเงินประกัน(ประกันภัยบุคคลที่ 3
                        วงเงินไม่ต่ำกว่า1ล้านบาท)
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_limit"
                        min={1000000}
                        maxLength={12}
                        type="text"
                        placeholder=" > 1,000,000 THB"
                        disabled={open}
                        className="form-input"
                        value={ins_limit_dummy}
                        onChange={handleInputCurrency}
                      />
                      <Form.Control.Feedback type="invalid">
                        กรุณาใส่จำนวนวงเงินตั้งแต่ 1,000,000 บาทค่ะ
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        ระยะเวลาเริ่มประกัน
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_start"
                        type="date"
                        placeholder=""
                        disabled={open}
                        className="form-input"
                        value={ins_start}
                        onChange={(e) => {
                          if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                            setIns_start(e.target.value);
                          }
                        }}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="6">
                      <Form.Label className="font-cen">
                        ระยะเวลาสิ้นสุดประกัน
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={weight > 25 || weight < 2 ? false : true}
                        id="ins_end"
                        type="date"
                        placeholder=""
                        disabled={open}
                        className="form-input"
                        value={ins_end}
                        onChange={(e) => {
                          if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                            setIns_end(e.target.value);
                          }
                        }}
                      />
                    </Form.Group>
                  </Row>
                  <br />
                  <Form.Label>
                    <h3 as={Col} className="header-main">
                      วันที่ครอบครองเครื่องวิทยุคมนาคมที่ใช้ในอากาศยานซึ่งไม่มีนักบิน
                    </h3>
                  </Form.Label>
                  <div className="card-main">
                    <div style={{ display: "block" }}>
                      <Form.Label className="font-censize">
                        <input
                          disabled={open}
                          id=""
                          type="checkbox"
                          name="option1"
                          value="1"
                          checked={chooselicense === "1"}
                          onChange={handleOptionChange}
                        />
                        &nbsp;นำเข้าตามใบอนุญาตนำเข้า
                        <br />
                        Imported according to the Import License
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          disabled={open}
                          type="checkbox"
                          name="option2"
                          value="2"
                          checked={chooselicense === "2"}
                          onChange={handleOptionChange}
                        />
                        ซื้อจากร้านค้า
                        <br />
                        Purchased from the distributor/store
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          disabled={open}
                          type="checkbox"
                          name="option3"
                          value="3"
                          checked={chooselicense === "3"}
                          onChange={handleOptionChange}
                        />
                        นำเข้ามาใช้งานในประเทศเป็นการชั่วคราว
                        <br />
                        Temporarilty imported in to the country
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          disabled={open}
                          type="checkbox"
                          name="option4"
                          value="4"
                          checked={chooselicense === "4"}
                          onChange={handleOptionChange}
                        />
                        รับโอนจากบุคคลอื่น
                        <br />
                        Transfered from the others
                      </Form.Label>
                      <Form.Label className="font-censize">
                        <input
                          disabled={open}
                          type="checkbox"
                          name="option5"
                          value="5"
                          checked={chooselicense === "5"}
                          onChange={handleOptionChange}
                        />
                        ทำขึ้นตามใบอนุญาต
                        <br />
                        Made according to the Assembly License
                      </Form.Label>
                    </div>
                    {chooselicense === "1" ? (
                      <div
                        style={{
                          position: "relative",
                          marginLeft: "150px",
                        }}
                      >
                        <Form.Label className="font-censize">
                          เลขใบอนุญาตนำเข้า<span className="text-red">*</span>
                          <br />
                          Import license number{" "}
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos1_1"
                          type="text"
                          name="file2"
                          pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                          maxLength={50}
                          disabled={open}
                          value={lic_req_data}
                          onChange={(e) => setLic_req_data(e.target.value)}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          วันที่นำเข้า (วัน/เดือน/ปี พ.ศ.)
                          <span className="text-red">*</span>
                          <br />
                          Import date (d M yyyy)
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos1_2"
                          type="date"
                          name="file2"
                          value={lic_req_data1}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data1(e.target.value);
                            }
                          }}
                          disabled={open}
                          className="form-input"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {chooselicense === "2" ? (
                      <div
                        style={{
                          position: "relative",
                          marginLeft: "150px",
                        }}
                      >
                        <Form.Label className="font-censize">
                          ชื่อร้านค้า<span className="text-red">*</span>
                          <br />
                          Store name{" "}
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos2_1"
                          pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                          maxLength={50}
                          type="text"
                          name="file2"
                          disabled={open}
                          value={lic_req_data}
                          onChange={(e) => setLic_req_data(e.target.value)}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          ตามใบเสร็จ/ใบกำกับภาษี ลงวันที่ (วัน/เดือน/ปี พ.ศ.)
                          <span className="text-red">*</span>
                          <br />
                          Bill date (d M yyyy)
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos2_2"
                          type="date"
                          name="file2"
                          //disabled
                          value={lic_req_data1}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data1(e.target.value);
                            }
                          }}
                          className="form-input"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {chooselicense === "3" ? (
                      <div
                        style={{
                          position: "relative",
                          marginLeft: "100px",
                        }}
                      >
                        <Form.Label className="font-censize">
                          วันที่เดินทางเข้าประเทศไทย/ Arrival date (mm dd, yyyy){" "}
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos3_1"
                          type="date"
                          name="date"
                          disabled={open}
                          value={lic_req_data}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data(e.target.value);
                            }
                          }}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          จำนวนวันที่พำนักในประเทศไทย (วัน)/
                          <span className="text-red">*</span>
                          <br />
                          Number of days of stay in Thailand (days)
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos3_2"
                          type="text"
                          pattern="[0-9]*"
                          maxLength={50}
                          name="date"
                          disabled={open}
                          value={lic_req_data1}
                          onChange={(e) => setLic_req_data1(e.target.value)}
                          className="form-input"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {chooselicense === "5" ? (
                      <div
                        style={{
                          position: "relative",
                          marginLeft: "100px",
                        }}
                      >
                        <Form.Label className="font-censize">
                          เลขที่ใบอนุญาตทำ<span className="text-red">*</span>
                          <br />
                          license number
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos5_1"
                          type="text"
                          name="file2"
                          pattern="[0-9]*"
                          maxLength={50}
                          disabled={open}
                          value={lic_req_data}
                          onChange={(e) => setLic_req_data(e.target.value)}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          วันที่ใบอนุญาตทำ (วัน/เดือน/ปี พ.ศ.)
                          <span className="text-red">*</span>
                          <br />
                          license date(d M yyyy)
                        </Form.Label>
                        <Form.Control
                          required
                          id="choos5_2"
                          type="date"
                          name="date"
                          disabled={open}
                          value={lic_req_data1}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data1(e.target.value);
                            }
                          }}
                          className="form-input"
                        />
                        <Form.Label className="font-censize">
                          วันที่ทำเครื่องวิทยุคมนาคม (วัน/เดือน/ปี พ.ศ.)
                          <span className="text-red">*</span>
                          <br />
                          made date radio communication device (d M yyyy)
                        </Form.Label>
                        <Form.Control
                          required
                          className="form-input"
                          id="choos5_3"
                          type="date"
                          name="date"
                          disabled={open}
                          value={lic_req_data2}
                          onChange={(e) => {
                            if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                              setLic_req_data2(e.target.value);
                            }
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {sessionStorage.getItem("type_user") === "corporation" ? (
                    <>
                      <Row className="mb-3 row-main">
                        <Form.Group as={Col} md="12">
                          <div style={{ display: "flex", width: "500px" }}>
                            <h3 as={Col} className="header-main">
                              ข้อมูลส่วนตัว
                            </h3>

                            <Button
                              onClick={editdrone}
                              //disabled={!disabless}
                              className="btnEdit"
                            >
                              <h4>แก้ไข</h4>
                            </Button>
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">
                            เลขทะเบียนนิติบุคคล
                          </Form.Label>
                          <Form.Control
                            disabled
                            className="form-input"
                            type="text"
                            value={data.legalentity_number}
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">
                            รหัสสาขา (ภพ. 20)
                          </Form.Label>
                          <Form.Control
                            disabled
                            required
                            type="text"
                            //placeholder={data.f_name}
                            value={data.branch_code}
                            className="form-input"
                          />
                          <Form.Control.Feedback>!</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">อีเมล</Form.Label>
                          <Form.Control
                            disabled
                            required
                            type="text"
                            //placeholder={data.l_name}
                            value={data.email}
                            className="form-input"
                          />
                          <Form.Control.Feedback>!</Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                      <Row className="mb-3 row-main">
                        <Form.Group as={Col} md="12">
                          <Form.Label className="font-cen">
                            ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                          </Form.Label>
                          <Form.Control
                            disabled
                            className="form-input"
                            type="text"
                            value={data.cur_address}
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">จังหวัด</Form.Label>
                          <>
                            <Form.Control
                              disabled
                              className="form-input"
                              type="text"
                              value={data.cur_province ? data.cur_province : ""}
                            />
                          </>
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">ตำบล</Form.Label>
                          <>
                            <Form.Control
                              disabled
                              className="form-input"
                              type="text"
                              value={data.cur_sub_dis ? data.cur_sub_dis : ""}
                            />
                          </>
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">อำเภอ</Form.Label>
                          <>
                            <Form.Control
                              disabled
                              className="form-input"
                              type="text"
                              value={data.cur_dis ? data.cur_dis : ""}
                            />
                          </>
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">
                            รหัสไปรษณีย์
                          </Form.Label>
                          <>
                            <Form.Control
                              disabled
                              className="form-input"
                              type="text"
                              value={data.cur_poscode ? data.cur_poscode : ""}
                            />
                          </>
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">
                            เบอร์โทรศัพท์
                          </Form.Label>
                          <Form.Control
                            disabled
                            className="form-input"
                            type="text"
                            //placeholder={data.l_name}
                            value={data.phone ? data.phone : ""}
                          />
                          <Form.Control.Feedback>!</Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                    </>
                  ) : (
                    <>
                      <br />
                      <Row className="mb-3 row-main">
                        <Form.Group as={Col} md="12">
                          <div style={{ display: "flex", width: "500px" }}>
                            <h3 as={Col} className="header-main">
                              ข้อมูลผู้ขอขึ้นทะเบียน
                            </h3>

                            <Button
                              onClick={editdrone}
                              //disabled={!disabless}
                              className="btnEdit"
                            >
                              <h4>แก้ไข</h4>
                            </Button>
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">
                            คำนำหน้าชื่อ
                          </Form.Label>

                          <Form.Control
                            disabled
                            value={data.title}
                            className="form-input"
                          ></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">ชื่อ</Form.Label>
                          <Form.Control
                            required
                            disabled={disabless}
                            type="text"
                            value={data.f_name}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">นามสกุล</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.l_name}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="12">
                          <Form.Label className="font-cen">
                            เลขบัตรประชาชน
                          </Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            //value="1-2345-12345-12-3"
                            value={data.idnum}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">อีเมล</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="email"
                            //value="name@example.com"
                            value={data.email}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">
                            เบอร์โทรศัพท์
                          </Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="number"
                            aria-label="Amount (to the nearest dollar)"
                            value={data.phone}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">อาชีพ</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.occupation}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="3">
                          <Form.Label className="font-cen">
                            วัน-เดือน-ปี เกิด
                          </Form.Label>
                          <Form.Control
                            disabled={disabless}
                            //type="date"
                            value={data.date_of_birth}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="3">
                          <Form.Label className="font-cen">อายุ</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="number"
                            value={data.age}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="3">
                          <Form.Label className="font-cen">
                            เชื้อชาติ
                          </Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.race}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="3">
                          <Form.Label className="font-cen">สัญชาติ</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.nationality}
                            className="form-input"
                          />
                        </Form.Group>
                      </Row>
                      <Row
                        className="mb-3"
                        style={{
                          marginTop: "75px",
                          marginLeft: "auto",
                          marginRight: "auto",
                          width: "1608px",
                          fontSize: "28px",
                          width: "100%",
                          padding: "0px 10px",
                        }}
                      >
                        <Form.Label>
                          <h3 as={Col} className="header-main">
                            ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน
                          </h3>
                        </Form.Label>
                        <Form.Group as={Col} md="8">
                          <Form.Label className="font-cen">
                            ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                          </Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.address}
                            className="form-input"
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">จังหวัด</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.province}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">ตำบล</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.sub_dis}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">อำเภอ</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.dis}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">
                            รหัสไปรษณีย์
                          </Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="number"
                            value={data.pos_code}
                            className="form-input"
                          />
                        </Form.Group>
                      </Row>
                      <Row
                        className="mb-3 row-main"
                        style={{
                          marginTop: "75px",
                        }}
                      >
                        <Form.Label>
                          <h3 as={Col} className="header-main">
                            ที่อยู่ปัจจุบัน
                          </h3>
                        </Form.Label>
                        <Form.Group as={Col} md="8">
                          <Form.Label className="font-cen">
                            ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                          </Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.cur_address}
                            className="form-input"
                          />
                        </Form.Group>

                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">จังหวัด</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.cur_province}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">ตำบล</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.cur_sub_dis}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">อำเภอ</Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="text"
                            value={data.cur_dis}
                            className="form-input"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="4">
                          <Form.Label className="font-cen">
                            รหัสไปรษณีย์
                          </Form.Label>
                          <Form.Control
                            disabled={disabless}
                            type="number"
                            value={data.cur_poscode}
                            className="form-input"
                          />
                        </Form.Group>
                      </Row>
                    </>
                  )}

                  <Row className="mb-3 row-main">
                    <Form.Label>
                      <h3 as={Col} className="header-main">
                        เอกสารที่นำส่ง
                      </h3>
                    </Form.Label>

                    <Form.Group as={Col} md="12">
                      <Form.Label
                        className="font-cen"
                        style={{ fontSize: "30px" }}
                      >
                        เอกสารแสดงตน
                      </Form.Label>
                      <Form.Label className="font-cen">
                        สำเนาบัตรประจำตัวประชาชน
                        <span style={{ color: "red" }}>***</span>
                      </Form.Label>

                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            id="idcard_file"
                            name="idcard_file"
                            type="file"
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            disabled={open}
                            className="form-importf"
                          />
                        </Col>

                        <Col>
                          <div
                            onClick={() => {
                              if (files.idcard_file.name === null) {
                              } else {
                                getfiletoshow(files.idcard_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              //disabled={open}
                              required
                              md={7}
                              className="form-import-val"
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.idcard_file === null
                                  ? "No file Chosen....."
                                  : files.idcard_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        สำเนาทะเบียนบ้าน
                        <span style={{ color: "red" }}>***</span>
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            id="homeregis_file"
                            type="file"
                            name="homeregis_file"
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            disabled={open}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (files.homeregis_file.name === null) {
                              } else {
                                getfiletoshow(files.homeregis_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              //disabled={open}
                              required
                              className="form-import-val"
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.homeregis_file === null
                                  ? "No file Chosen....."
                                  : files.homeregis_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Label
                        className="font-cen"
                        style={{ fontSize: "30px" }}
                      >
                        เอกสารแสดงลักษณะทางเทคนิค
                      </Form.Label>
                      <Form.Label className="font-cen">
                        รูปถ่ายของ Drone / UAV’s picture
                        <span style={{ color: "red" }}>***</span>
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            id="dronepic_file"
                            type="file"
                            name="dronepic_file"
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            disabled={open}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (files.dronepic_file.name === null) {
                              } else {
                                getfiletoshow(files.dronepic_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              //disabled={open}
                              required
                              className="form-import-val"
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.dronepic_file === null
                                  ? "No file Chosen....."
                                  : files.dronepic_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        รูปถ่ายหมายเลขประจำเครื่อง Drone ที่เห็น QR CODE/Bar
                        Code ที่ชัดเจน <span style={{ color: "red" }}>***</span>
                        <br />A photograph of the drone's serial number with a
                        clear QR Code / Bar Code.
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            id="droneserial_file"
                            type="file"
                            name="droneserial_file"
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            disabled={open}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (files.droneserial_file.name === null) {
                              } else {
                                getfiletoshow(files.droneserial_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              //disabled={open}
                              required
                              className="form-import-val"
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.droneserial_file === null
                                  ? "No file Chosen....."
                                  : files.droneserial_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        รูปถ่ายหมายเลขประจำเครื่องอุปกรณ์ควบคุมการบิน Drone
                        ที่เห็น QR CODE/Bar Code ที่ชัดเจน
                        <span style={{ color: "red" }}>***</span>
                        <br />A photograph of the remote controller's serial
                        number with a clear QR Code / Bar Code
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            id="remoteserial_file"
                            type="file"
                            name="remoteserial_file"
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            disabled={open}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (files.remoteserial_file.name === null) {
                              } else {
                                getfiletoshow(files.remoteserial_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              //disabled={open}
                              required
                              className="form-import-val"
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.remoteserial_file === null
                                  ? "No file Chosen....."
                                  : files.remoteserial_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        หนังสือรับรองตนเอง
                        <span style={{ color: "red" }}>***</span>
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            id="selfcert_file"
                            type="file"
                            name="selfcert_file"
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            disabled={open}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (files.selfcert_file.name === null) {
                              } else {
                                getfiletoshow(files.selfcert_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              //disabled={open}
                              required
                              className="form-import-val"
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.selfcert_file === null
                                  ? "No file Chosen....."
                                  : files.selfcert_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        สำเนาเอกสารประกันภัยอากาศยาน
                        <span style={{ color: "red" }}>***</span>
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            id="aircraft_insu_file"
                            type="file"
                            name="aircraft_insu_file"
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            disabled={open}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (files.aircraft_insu_file.name === null) {
                              } else {
                                getfiletoshow(files.aircraft_insu_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              //disabled={open}
                              required
                              className="form-import-val"
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.aircraft_insu_file === null
                                  ? "No file Chosen....."
                                  : files.aircraft_insu_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group as={Col} md="12">
                      <Form.Label
                        className="font-cen"
                        style={{ fontSize: "30px" }}
                      >
                        เอกสารหลักฐานเพิ่มเติมกรณีมอบอำนาจ
                      </Form.Label>
                      <Form.Label className="font-cen">
                        หนังสือมอบอำนาจ / Power of Attorney document
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            //required
                            id="attorney_doc_file"
                            type="file"
                            name="attorney_doc_file"
                            disabled={open}
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (files.attorney_doc_file.name === null) {
                              } else {
                                getfiletoshow(files.attorney_doc_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              className="form-import-val"
                              //disabled={open}
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.attorney_doc_file === null
                                  ? "No file Chosen....."
                                  : files.attorney_doc_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        สำเนาบัตรประจำตัวประชาชนผู้มอบอำนาจ / Copy of ID card of
                        the authorized person.
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            //required
                            id="idcard_attorneyauth_file"
                            type="file"
                            name="idcard_attorneyauth_file"
                            disabled={open}
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (
                                files.idcard_attorneyauth_file.name === null
                              ) {
                              } else {
                                getfiletoshow(
                                  files.idcard_attorneyauth_file.path
                                );
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              className="form-import-val"
                              //disabled={open}
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.idcard_attorneyauth_file === null
                                  ? "No file Chosen....."
                                  : files.idcard_attorneyauth_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        สำเนาบัตรประจำตัวประชาชนผู้รับมอบอำนาจ / Copy of ID card
                        of the Attorney.
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            //required
                            id="idcard_attorney_file"
                            type="file"
                            name="idcard_attorney_file"
                            disabled={open}
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (files.idcard_attorney_file.name === null) {
                              } else {
                                getfiletoshow(files.idcard_attorney_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              className="form-import-val"
                              //disabled={open}
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.idcard_attorney_file === null
                                  ? "No file Chosen....."
                                  : files.idcard_attorney_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Label
                        className="font-cen"
                        style={{ fontSize: "30px" }}
                      >
                        เอกสารดำเนินคดี
                      </Form.Label>
                      <Form.Label className="font-cen">
                        ผลการดำเนินคดี / Legal result
                      </Form.Label>
                      <Row className="mb-3">
                        <Col md={2} style={{ display: "block" }}>
                          <Form.Control
                            //required
                            id="legal_result_file"
                            type="file"
                            name="legal_result_file"
                            disabled={open}
                            onChange={(e) => {
                              handleFiles(e);
                            }}
                            className="form-importf"
                          />
                        </Col>
                        <Col md={10}>
                          <div
                            onClick={() => {
                              if (files.legal_result_file.name === null) {
                              } else {
                                getfiletoshow(files.legal_result_file.path);
                              }
                            }}
                          >
                            <Form.Control
                              style={{ cursor: "pointer" }}
                              className="form-import-val"
                              //disabled={open}
                              type="text"
                              placeholder="No file Chosen....."
                              value={
                                files.legal_result_file === null
                                  ? "No file Chosen....."
                                  : files.legal_result_file.name
                              }
                              readOnly
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                  </Row>

                  {open ? (
                    ""
                  ) : (
                    <div
                      className="grid-item"
                      style={{ display: "flex", justifyContent: "end" }}
                    >
                      <button
                        className="custom-btn btnSave"
                        style={{
                          width: "200px",
                          height: "87px",
                          fontSize: "31px",
                        }}
                        //onClick={() => setShow(true)}
                      >
                        นำส่งข้อมูล
                      </button>
                    </div>
                  )}
                </Form>
                <br />
                {state.status === "ร่างเอกสาร" && !open ? (
                  <div
                    className="grid-item"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <button
                      className="custom-btn btnEdit2"
                      style={{
                        width: "200px",
                        height: "87px",
                        fontSize: "31px",
                      }}
                      onClick={() => {
                        setSaveedit(false);
                        setShow(true);
                      }}
                    >
                      บันทึกข้อมูล
                    </button>
                  </div>
                ) : (
                  ""
                )}

                <Form noValidate>
                  <Modal
                    show={updatedata}
                    onHide={handleClose}
                    className="font-cen"
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>บันทึกข้อมูล</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>ข้อมูลส่วนตัวจะถูกบันทึกใหม่</Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        ยกเลิก
                      </Button>
                      <Button variant="primary" onClick={handleUpdatesuc}>
                        ยืนยัน
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    show={bt_cancel}
                    onHide={()=>setBt_cancel(false)}
                    className="font-cen"
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>แจ้งเตือน</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>ท่านยืนยันที่ยกเลิกเอกสาร Drone</Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={()=>setBt_cancel(false)}>
                        ยกเลิก
                      </Button>
                      <Button variant="primary" onClick={()=>cancleDrones()}>
                        ยืนยัน
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    show={updatedatasuc}
                    onHide={handleClose}
                    className="font-cen"
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>บันทึกข้อมูลสำเร็จ</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <img
                        src={check}
                        style={{
                          width: "100px",
                          height: "100px",
                          padding: "3%",
                          marginLeft: "180px",
                        }}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        ยกเลิก
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    show={showdelete}
                    onHide={() => setshowdelete(false)}
                    className="font-cen"
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>ลบข้อมูล</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      ท่านยืนยันที่ต้องการลบข้อมูลการขอขึ้นทะเบียนโดรนหรือไม่
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setshowdelete(false)}
                      >
                        ยกเลิก
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => deleteDoc(state.drone_id)}
                      >
                        ยืนยัน
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {saveedit ? (
                    <Modal
                      show={show}
                      onHide={() => setShow(false)}
                      className="font-cen"
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>บันทึกข้อมูลการขอขึ้นทะเบียน</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>ข้อมูลส่วนตัวจะถูกบันทึกใหม่</Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => setShow(false)}
                        >
                          ยกเลิก
                        </Button>
                        <Button
                          variant="primary"
                          onClick={() => handleSendsuc()}
                        >
                          บันทึกข้อมูล
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  ) : (
                    <Modal
                      show={show}
                      onHide={() => setShow(false)}
                      className="font-cen"
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>นำส่งข้อมูลการขอขึ้นทะเบียน</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        ข้อมูลส่วนตัวจะถูกบันทึกใหม่และนำส่งข้อมูลการขอขึ้นทะเบียน
                        Drone
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => setShow(false)}
                        >
                          ยกเลิก
                        </Button>
                        <Button
                          variant="primary"
                          onClick={() => handleSendsuc()}
                        >
                          นำส่งข้อมูล
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {/* <Modal
                    show={show}
                    onHide={() => setShow(false)}
                    className="font-cen"
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>นำส่งข้อมูลการขอขึ้นทะเบียน</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      ข้อมูลส่วนตัวจะถูกบันทึกใหม่และนำส่งข้อมูลการขอขึ้นทะเบียน
                      Drone
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShow(false)}
                      >
                        ยกเลิก
                      </Button>
                      <Button variant="primary" onClick={handleSendsuc}>
                        นำส่งข้อมูล
                      </Button>
                    </Modal.Footer>
                  </Modal> */}
                  <Modal
                    show={senddata}
                    onHide={() => setSenddata(false)}
                    className="font-cen"
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>นำส่งข้อมูลสำเร็จ</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <img
                        alt="check"
                        src={check}
                        style={{
                          width: "100px",
                          height: "100px",
                          padding: "3%",
                          marginLeft: "180px",
                        }}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        ปิด
                      </Button>
                      <Button variant="primary" onClick={next}>
                        ดูสถานะ
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Modal
                    show={checkuserdata}
                    centered
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    className="font-cen"
                    //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
                  >
                    <Modal.Body
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        //background: "black",
                      }}
                    >
                      <h3>no user data</h3>
                    </Modal.Body>
                  </Modal>
                </Form>
                {/* {open ? (
                  ""
                ) : (
                  <div
                    className="grid-item"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <button
                      className="custom-btn btnSave"
                      style={{
                        width: "300px",
                        height: "87px",
                        fontSize: "31px",
                      }}
                      onClick={() => setShow(true)}
                    >
                      นำส่งข้อมูล
                    </button>
                  </div>
                )} */}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
export default Datadrone;
